import React from 'react';
import { AnchorsList } from '@vfit/shared/components';
import { IMoreOfferSelector } from '../../moreOfferSelector.models';

const MoreOfferDesktop = ({ title, elements }: IMoreOfferSelector) => {
  if (elements?.length === 0) return null;
  return (
    <AnchorsList
      anchors={
        elements?.map((e) => {
          return {
            anchorLabel: e?.title || '',
            anchorLink: e?.url || '',
          };
        }) || []
      }
      title={title}
      isDarkMode={false}
    />
  );
};

export default MoreOfferDesktop;
